import ReservedProductsHtml from './products.reserved.html';

export function ProductReservedDirective () {
  return {
    controller: 'ReservedProductsCtrl',
    restrict  : 'E',
    scope     : {
      product : '=',
      reserved: '='
    },
    templateUrl: ReservedProductsHtml,
  };
};